import { render, staticRenderFns } from "./IrOrdersSearchByTags.vue?vue&type=template&id=a82a7aca&"
import script from "./IrOrdersSearchByTags.vue?vue&type=script&lang=js&"
export * from "./IrOrdersSearchByTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports